import { Icon } from "@vds/icons";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  invalidateTokenApi,
} from "../../api/SessionServiceManager";
import { setLogoutInProgress } from "../axiosInterceptor";
import { stopIdleTimer } from "../idleTimeModal";
import { cancelTokenRefresh } from "../proactiveTokenRefresh";
import { useNavigate } from "react-router-dom";
import { Line } from "@vds/lines";
import { Loader } from "@vds/loaders";
import {
  resetApp,
  setUserActiveSession,
  updateSelectedLeftNav,
} from "../../store/actions";
import { useEffect, useState } from "react";
import { getLeftNavSelection } from "../managers/NavServiceManager";
import { clearAllCookies } from "../utility/Utils";
import { ROUTES } from "../constants/routesConstants";

const NavMenu = (props) => {
  let navigate = useNavigate();
  const location = useLocation();
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const selectedLeftNav = useSelector(
    (state) => state.sessionReducer.selectedLeftNav
  );
  const [isLoading, setIsLoading] = useState(false);
  const { menuList, menuName, menuItems, menuLists, disabled, collapsed, iconSize = "medium" } = props;
  const { state } = useLocation();
  const dispatch = useDispatch();
  const isHistoricalSearchEnabled = window.REACT_APP_HISTORICAL_SEARCH_ENABLED;
  const isV1OnlyAccount = useSelector((state) => state.licenseReducer.isV1OnlyAccount);

  /* Commenting out line to remove search functina;ity basis on Search License temporarily. */
  const shouldHideSearch = isHistoricalSearchEnabled !== "true" || isV1OnlyAccount;
  const filteredMenuItems = menuItems.filter((item) => item.name !== "Trends" && !(shouldHideSearch && item.name === "Search"));
 //const filteredMenuItems = menuItems.filter((item) => item.name !== "Trends");
  useEffect(() => {
    let pageType = getLeftNavSelection(location?.pathname);
    dispatch(updateSelectedLeftNav(pageType));
  }, [location]);

  const logoutHandler = async () => {
    setIsLoading(true);
    setLogoutInProgress(true);
    cancelTokenRefresh();
    stopIdleTimer();
    try {
      await invalidateTokenApi(activeSession).catch(() => {});
      dispatch(resetApp());
      clearAllCookies();
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace(window.location.origin + ROUTES.LOGIN);
    } catch (error) {
      console.error("Error during logout:", error);
      window.location.replace(window.location.origin + ROUTES.LOGIN);
    } finally {
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return <Loader active={true} fullscreen={true} disableFocusLock></Loader>;
  }

  return (
    <div
      className="sasp_nav-menu sasp_vz-nhg-eds-font"
      style={{ color: "#fff" }}
    >
      <span
        className="sasp_text-overflow-ellipsis"
        style={{ fontWeight: 700, paddingLeft: "15px" }}
      >
        {/* {menuName} */}
      </span>
      <ul
        style={{
          listStyle: "none",
          padding: "0px",
          paddingLeft: "0px",
          orientation: "horizontal",
          indicatorPosition: "bottom",
        }}
      >
        {filteredMenuItems.map((item, index) => (
          <li
            key={index}
            className="nav-menu-item"
          >
            {item.isExternalLink && (
              <a
                className={`sasp_inactive-menu-link ${disabled ? 'is-disabled' : ''}`}
                href={item.path}
                target="_blank"
                style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
              >
                <div
                  className="sasp_text-overflow-ellipsis"
                  style={{ padding: "5px 15px", paddingRigh: "0px" }}
                  title={item.name}
                >
                  <Icon
                    name={item.icon ? item.icon : "dashboard"}
                    color={disabled ? '#a8a8a8' : '#ffffff'}
                    size="medium"
                  />
                  <span
                    style={{ paddingLeft: "10px", verticalAlign: "middle", color: disabled ? '#a8a8a8' : '#ffffff' }}
                  >
                    {item.name}
                  </span>
                </div>
              </a>
            )}
            {!item.isExternalLink && (
              <>
                {item?.hasSubMenu && (
                  <>
                    <li className="nav-menu-item">
                      <div
                        className={`${state?.tabName
                          ? "sasp_active-menu-link"
                          : "sasp_inactive-menu-link"
                          } ${disabled ? 'is-disabled' : ''}`}
                        end
                        style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                      >
                        <div
                          className="sasp_text-overflow-ellipsis"
                          style={{ padding: "8px 15px", paddingRigh: "0px" }}
                          title={item.name}
                        >
                          {item?.icon && (
                            <Icon name={item.icon} color={disabled ? '#a7a7a7' : '#ffffff'} size="medium" />
                          )}
                          <span
                            style={{
                              paddingLeft: "10px",
                              verticalAlign: "middle",
                              color: disabled ? '#a8a8a8' : '#fff'
                            }}
                          >
                            {item.name}
                          </span>
                        </div>
                      </div>

                      <ul
                        style={{
                          listStyle: "none",
                          padding: "0px",
                          paddingLeft: "0px",
                        }}
                      >
                        {item.subMenu.map((item2) => {
                          return (
                            <li className="nav-menu-item">
                              <Link
                                data-testid="navMenu_navMenuItemsLink"
                                to={item2?.path}
                                state={item2.state}
                                style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                              >
                                <div
                                  className="sasp_text-overflow-ellipsis"
                                  style={{
                                    padding: "8px 40px",
                                  }}
                                  title={item2.name}
                                >
                                  {item?.icon && (
                                    <Icon
                                      name={item2.icon}
                                      color={disabled ? '#a8a8a8' : '#ffffff'}
                                      size="medium"
                                    />
                                  )}
                                  <span
                                    style={{
                                      paddingLeft: "10px",
                                      harizontalAlign: "middle",
                                      color: disabled ? '#a8a8a8' : '#fff'
                                    }}
                                  >
                                    {item2.name}
                                  </span>
                                </div>
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  </>
                )}
                {!item?.hasSubMenu && item.name !== "Log out" && (
                  <>
                    {item.name === "Settings" && !collapsed && (
                      <hr
                        style={{
                          border: "none",
                          borderTop: "2px solid #ccc",
                          margin: "0 15px",
                          marginTop: "30px",
                          marginBottom: "10px",
                        }}
                      />
                    )}
                    <NavLink
                      to={item?.path}
                      className={
                        selectedLeftNav === item.name
                          ? "sasp_active-menu-links"
                          : "sasp_inactive-menu-link"
                      }
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: collapsed ? "10px 0" : "8px 15px",
                        justifyContent: collapsed ? "center" : "flex-start",
                        textDecoration: "none",
                        paddingBottom: collapsed ? "10px" : "0px",
                        ...(disabled && { pointerEvents: 'none', opacity: 0.5 })
                      }}
                    >
                      {item?.icon && (
                        <div
                          style={{
                            backgroundColor:
                              selectedLeftNav === item.name && !disabled
                                ? "#fff"
                                : "transparent",
                            borderRadius: "50%",
                            padding:
                              selectedLeftNav === item.name ? "8px" : "0",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: collapsed ? "32px" : "36px",
                            height: collapsed ? "32px" : "43px",
                            boxShadow:
                              selectedLeftNav === item.name && !disabled
                                ? "0 2px 4px rgba(0, 0, 0, 0.2)"
                                : "none",
                            transition: "all 0.3s ease",
                            marginRight: collapsed ? "0" : "5px",
                          }}
                        >
                          <Icon
                            name={item.icon}
                            color={
                              selectedLeftNav === item.name && !disabled ? "#000000" : (disabled ? '#a8a8a8' : "#ffffff")
                            }
                            size={iconSize}
                          />
                        </div>
                      )}

                      {!collapsed && (
                        <span
                          style={{
                            color: disabled ? '#a8a8a8' : '#fff',
                            fontSize:
                              selectedLeftNav === item.name && !disabled ? "20px" : "14px",
                            fontWeight:
                              selectedLeftNav === item.name && !disabled ? "bold" : "normal",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {item.name}
                        </span>
                      )}
                    </NavLink>
                  </>
                )}
                {!item?.hasSubMenu && item.name === "Log out" && (
                  <div>
                    {!collapsed && (
                      <hr
                        style={{
                          border: "none",
                          borderTop: "2px solid #ccc",
                          margin: "0 15px",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      />
                    )}

                    <NavLink
                      // to={item?.path}
                      onClick={logoutHandler}
                      className={"sasp_inactive-menu-link"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: collapsed ? "8px 0" : "8px 15px",
                        justifyContent: collapsed ? "center" : "flex-start",
                      }}
                    >
                      {item?.icon && (
                        <Icon name={item.icon} color="#ffffff" size={iconSize} />
                      )}
                      {!collapsed && (
                        <span
                          style={{
                            paddingLeft: "10px",
                            verticalAlign: "middle",
                          }}
                        >
                          {item.name}
                        </span>
                      )}
                    </NavLink>
                  </div>
                )}
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NavMenu;
